<template>
    <form-template @submit="proceed">
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Select Channel</p>
        </div>
        <div class="col-span-4 md:col-span-3">
            <div class="grid grid-cols-2 gap-5 md:gap-10">
                <div class="col-span-2 md:col-span-1">
                    <biller-radio
                        @select="(val) => (data.withdrawal_channel = val)"
                        value="atm"
                        :active="data.withdrawal_channel === 'atm'"
                    >
                        <p class="text-grey-300 text-sm">ATM</p>
                    </biller-radio>
                </div>
                <div class="col-span-2 md:col-span-1">
                    <biller-radio
                        @select="(val) => (data.withdrawal_channel = val)"
                        value="pos"
                        :active="data.withdrawal_channel === 'pos'"
                    >
                        <p class="text-grey-300 text-sm">POS</p>
                    </biller-radio>
                </div>
            </div>
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Amount</p>
        </div>
        <div class="col-span-4 md:col-span-3 relative">
            <biller-input
                placeholder="Input Amount"
                largeValue
                type="text"
                :value="input"
                @input="updateAmount"
                required
            >
                <template v-slot:append>
                    <img src="@/assets/svg/naira-icon.svg" alt="Nigerian Naira icon" />
                </template>
            </biller-input>
        </div>
        <div class="col-span-4 md:col-span-1">
            <p class="text-smoke-dark text-sm">Withdrawal Pin</p>
        </div>
        <div class="col-span-4 md:col-span-3 relative">
            <biller-input type="password" v-model="data.withdrawal_pin" placeholder="Input Withdrawal Pin" />
        </div>
    </form-template>
</template>

<script>
import { formatAmount } from '@/util/formatAmount'
export default {
    data() {
        return {
            data: {
                withdrawal_channel: '',
                withdrawal_pin: '',
                amount: 0,
            },
            input: '',
        }
    },

    methods: {
        updateAmount(val) {
            this.input = val.replace(/[^\d]/g, '')
            this.$forceUpdate()
        },

        proceed(val) {
            const fullData = Object.assign(this.data, val)
            this.$emit('proceed', fullData)
        },
    },

    watch: {
        input: function(newValue) {
            let val = newValue
                .toString()
                .split(',')
                .join('')
            this.data.amount = parseInt(val)
            this.input = formatAmount(val)
        },
    },
}
</script>

<style></style>
